<template>

    <div class="ibox contactBox">

        <!-- header -->
        <div :class="['contact-container']">
            <p class="font-size-18 bold">
                <span class="large-contact-container-number">{{ index == 0 ? 'Primary' : 'Secondary'}} contact</span>
                <span v-if="index !== 0" style=" cursor: pointer;" @click="deleteContactBox(index)">
                      <span class="float-right">
                          <a href="javascript:void(0)">
                               <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                   <path fill-rule="evenodd" clip-rule="evenodd"
                                         d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 8.59L13.59 5L15 6.41L11.41 10L15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59Z"
                                         fill="#03A9F4"/>
                               </svg>
                          </a>
                      </span>
                </span>
                <span v-else style="  cursor: pointer;" @click="addContactBox">
                       <div class="btn-group pull-right" >
                        <span  class="float-right"   style="margin-top: 3px;">
                              <a href="#">
                                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                           xmlns="http://www.w3.org/2000/svg"> <path
                                          d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                                          fill="#03A9F4"/> </svg>
                                  </a>
                       </span>
                              <span  v-if="!isMobile()" class="select-services-dropdown-add-label float-right"><a href="javascript:;" style="text-decoration: none; font-family: 'Roboto';font-style: normal;font-weight: 600;font-size: 14px;line-height: 24px;color: #2E4051;">Add secondary contact &nbsp;&nbsp;</a></span>
                          </div>
                      </span>
            </p>
        </div>

        <!-- start name inputs -->
        <div class="form-group m-bottom-0">
            <div v-for="(name, key) in contactBox.nameInputs" :class="['row', key !==0 ? 'p-top-10' : '' ]" >
                <div class="col-md-1 col-xs-4 m-bottom-0">

                    <div :class="{'form-group':true}">
                        <div class="input-container">

                            <select class="contact-new-input width-unset ipad-padding p-bottom-0-imp" v-model="name.title">
                                <option v-for="title in apisData.contactTitles" :value="title.key"> {{ title.value }}</option>
                            </select>
                            <label class="label-left">Title</label>

                        </div>
                    </div>
                </div>

                <validation-provider :rules="'required'" :name="`first_name_${index}_${key}`" v-slot="{errors}">
                    <div class="col-md-5 col-xs-8 m-bottom-0 first-name-position">

                        <div :class="{'form-group':true,'has-error':errors.length}">
                            <div class="input-container">

                                <input :class="{'contact-new-input first-name-contact-new-input': true}"
                                       type="text"
                                       :name="`first_name_${index}_${key}`"
                                       v-model="name.first_name"
                                       style="padding-top: 30px !important;">
                                <label>First name</label>

                            </div>
                            <span class="text text-danger error-label">{{ errors[0] }}</span>
                        </div>
                    </div>
                </validation-provider>

                <validation-provider :rules="'required'" :name="`last_name_${index}_${key}`" v-slot="{errors}">
                    <div class="col-md-5 col-xs-10 m-bottom-0">

                        <div :class="{'form-group':true,'has-error':errors.length}">
                            <div class="input-container">

                                <input :class="{'contact-new-input': true, 'width-106-mobile': true}"
                                       :name="`last_name_${index}_${key}`" type="text" v-model="name.last_name" style="padding-top: 30px !important;">
                                <label>Last name</label>

                            </div>
                            <span class="text text-danger error-label">{{ errors[0] }}</span>
                        </div>
                    </div>
                </validation-provider>

                <div class="col-md-1 col-xs-2 m-bottom-0">
                    <div>
                        <p class="font-size-18 bold">
                            <span style="  cursor: pointer;" @click="addInput('name')" v-if="key == 0 && index == 0">
                                  <span class="float-right">
                                      <a href="javascript:void(0)">
                                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                               xmlns="http://www.w3.org/2000/svg"> <path
                                              d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                                              fill="#03A9F4"/>
                                          </svg>
                                      </a>
                                  </span>
                            </span>
                            <span style="  cursor: pointer;" @click="deleteInput('name', key)" v-if="key !== 0">
                                  <span class="float-right">
                                      <a href="javascript:void(0)">
                                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                               xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 8.59L13.59 5L15 6.41L11.41 10L15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59Z"
                                                      fill="#03A9F4"/>
                                        </svg>
                                     </a>
                                  </span>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- end name inputs -->

        <!-- start email inputs -->
        <div class="form-group m-bottom-0">
            <div v-for="(email, key) in contactBox.emailInputs" :class="['row', key !==0 ? 'p-top-10' : '' ]" >

                <div class="col-md-11 col-xs-10 m-bottom-0">
                    <div :class="{'form-group':true}">
                        <div class="input-container">
                            <input :class="{'contact-new-input': true, 'width-106-mobile': true}"
                                   type="email" v-model="email.email" style="padding-top: 30px !important;">
                            <label>Email</label>
                        </div>
                    </div>
                </div>

                <div class="col-md-1 col-xs-2 m-bottom-0">
                    <div>
                        <p class="font-size-18 bold">
                        <span style="  cursor: pointer;" @click="addInput('email')" v-if="key == 0">
                              <span class="float-right">
                                  <a href="javascript:void(0)">
                                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                           xmlns="http://www.w3.org/2000/svg"> <path
                                          d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                                          fill="#03A9F4"/> </svg>
                                  </a>
                              </span>
                        </span>
                            <span style="  cursor: pointer;" @click="deleteInput('email', key)" v-if="key !== 0">
                              <span class="float-right">
                                  <a href="javascript:void(0)">
                                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                           xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 8.59L13.59 5L15 6.41L11.41 10L15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59Z"
                                                  fill="#03A9F4"/>
                                            </svg>

                                  </a>
                              </span>
                        </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- end email inputs -->

        <!-- start mobile inputs -->
        <div class="form-group m-bottom-0">
            <div v-for="(mobile, key) in contactBox.mobileInputs" :class="['row', key !==0 ? 'p-top-10' : '' ]">
                <div class="col-md-11 col-xs-10 m-bottom-0">
                    <div :class="{'input-group': mobile.showCode }">
                        <span class="input-group-addon input-group-new-design-left" v-if="mobile.showCode">
                            <select :ref="'mobile_select_code_'+key" style="border: none; background: #FFFFFF;" id="countryCode"
                                    v-model="mobile.code"
                                    @change="updateSelectedText('mobile_select_code_'+key, mobile.code)">
                                <option v-for="code in apisData.countriesData"
                                        :value="code.country_key+'_'+code.country_name"
                                        :data-text="`${code.country_name} (${code.country_key})`">
                                    {{ code.country_name }} ( {{ code.country_key }} )
                                </option>
                            </select>
                        </span>

                        <div :class="{'has-error':validationErrors[`mobile_${index}_${key}`]}">
                            <div class="input-container">
                                <input :class="{'contact-new-input': true, 'input-group-addon-new-design-right': mobile.showCode,
                                                 'width-106-mobile': ! mobile.showCode, 'width-109-mobile': mobile.showCode,}"
                                       type="number"
                                       :name="`mobile_${index}_${key}`" v-model="mobile.mobile" style="padding-top: 30px !important;">
                                <label :class="{'left-48': mobile.showCode }">Mobile</label>
                            </div>
                        </div>
                    </div>

                    <div>
                        <span class="text text-danger error-label">{{ validationErrors[`mobile_${index}_${key}`] }}</span>
                    </div>

                    <span>
                        <a href="javascript:void(0)" class="contact-container-number"
                           @click="mobile.showCode=!mobile.showCode;
                           mobile.code.length > 1 ? mobile.code : mobile.code=countryData.country_key+'_'+countryData.country_name;
                           updateSelectedText('mobile_select_code_'+key, (mobile.code != null ? mobile.code : countryData.country_key+'_'+countryData.country_name));"
                           style="text-decoration: none">
                        {{ mobile.showCode ? 'Hide' : 'Show' }} country code
                    </a></span>
                </div>

                <div class="col-md-1 col-xs-2 m-bottom-0">
                    <div>
                        <p class="font-size-18 bold">
                            <span style="  cursor: pointer;" @click="addInput('mobile')" v-if="key == 0">
                                  <span class="float-right">
                                      <a href="javascript:void(0)">
                                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                               xmlns="http://www.w3.org/2000/svg"> <path
                                              d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                                              fill="#03A9F4"/> </svg>
                                      </a>
                                  </span>
                            </span>
                            <span style="  cursor: pointer;" @click="deleteInput('mobile', key)" v-if="key !== 0">
                                  <span class="float-right">
                                      <a href="javascript:void(0)">
                                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                               xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 8.59L13.59 5L15 6.41L11.41 10L15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59Z"
                                                      fill="#03A9F4"/>
                                                </svg>

                                      </a>
                                  </span>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- end mobile inputs -->

        <!-- start phone inputs -->
        <div class="form-group m-bottom-0">
            <div v-for="(phone, key) in contactBox.phoneInputs" :class="['row', key !==0 ? 'p-top-10' : '' ]">
                <div class="col-md-11 col-xs-10 m-bottom-0">
                    <div :class="{'input-group': phone.showCode }">
                        <span class="input-group-addon input-group-new-design-left" v-if="phone.showCode">
                            <select :ref="'phone_select_code_'+key" style="border: none; background: #FFFFFF;" id="countryCode" v-model="phone.code"
                                    @change="updateSelectedText('phone_select_code_'+key, phone.code);">
                                <option v-for="code in apisData.countriesData"
                                        :value="code.country_key+'_'+code.country_name"
                                        :data-text="`${code.country_name} (${code.country_key})`">
                                    {{ code.country_name }} ( {{ code.country_key }} )
                                </option>
                            </select>
                        </span>



                        <div :class="{'has-error':validationErrors[`mobile_${index}_${key}`]}">
                            <div class="input-container">

                                <input :class="{'contact-new-input': true, 'input-group-addon-new-design-right': phone.showCode,
                                         'width-106-mobile': ! phone.showCode, 'width-109-mobile': phone.showCode}"
                                        type="number"
                                        :name="`phone_${index}_${key}`" v-model="phone.phone" style="padding-top: 30px !important;">

                                <label :class="{'left-48': phone.showCode }">Phone</label>

                            </div>
                        </div>

                    </div>
                    <div>
                        <span class="text text-danger error-label">{{ validationErrors[`phone_${index}_${key}`] }}</span>
                    </div>
                    <span>
                        <a href="javascript:void(0)" class="contact-container-number"
                           @click="phone.showCode=!phone.showCode;phone.code=countryData.country_key+'_'+countryData.country_name;
                                  updateSelectedText('phone_select_code_'+key, countryData.country_key+'_'+countryData.country_name);">
                        {{ phone.showCode ? 'Hide' : 'Show' }} country code
                         </a>

                    </span>
                </div>

                <div class="col-md-1 col-xs-2 m-bottom-0">
                    <div>
                        <p class="font-size-18 bold">
                            <span style="  cursor: pointer;" @click="addInput('phone')" v-if="key == 0">
                                  <span class="float-right">
                                      <a href="javascript:void(0)">
                                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                               xmlns="http://www.w3.org/2000/svg"> <path
                                              d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                                              fill="#03A9F4"/> </svg>
                                      </a>
                                  </span>
                            </span>
                            <span style="  cursor: pointer;" @click="deleteInput('phone', key)" v-if="key !== 0">
                                  <span class="float-right">
                                      <a href="javascript:void(0)">
                                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                               xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                      d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 8.59L13.59 5L15 6.41L11.41 10L15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59Z"
                                                      fill="#03A9F4"/>
                                                </svg>

                                      </a>
                                  </span>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- end phone inputs -->

        <!-- start fax inputs-->
        <div v-if="index == 0" class="form-group m-bottom-0">
            <div class="row">
                <div class="col-md-12 m-bottom-0">
                    <div :class="{'form-group':true}">
                        <div class="input-container">
                            <input class="contact-new-input" type="text" id="fax" v-model="dataSubmit.fax" style="padding-top: 30px !important;">
                            <label>Fax</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end fax inputs-->

        <!-- start P.O box inputs-->
        <div v-if="index == 0" class="form-group">
            <div class="row">
                <div class="col-md-12 m-bottom-0">

                    <div class="input-container">
                        <input class="contact-new-input" type="text" id="box" v-model="dataSubmit.poBox" style="padding-top: 30px !important;">
                        <label>P.O. Box</label>
                    </div>
                </div>
            </div>
        </div>
        <!-- end P.O box inputs-->


        <!-- start note input -->
        <div class="form-group m-bottom-0">
            <div class="row">
                <div class="col-md-12 m-bottom-0" v-if="showNotesField || contactBox.noteInput">
                    <div :class="{'form-group':true}">
                        <div class="input-container">
                            <textarea rows="1" class="contact-new-input form-control" v-model="contactBox.noteInput" style="border-radius: 8px;padding-top: 30px !important;height: auto !important;"></textarea>
                            <label>Add notes to contact</label>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 m-bottom-0" v-if="!showNotesField && ! contactBox.noteInput">
                    <div class="btn-group pull-right">
                        <span data-toggle="dropdown" class="float-right" aria-expanded="false" @click="toggleNotesField" style="margin-top: 3px;">
                              <a href="javascript:void(0)">
                                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                           xmlns="http://www.w3.org/2000/svg"> <path
                                          d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                                          fill="#03A9F4"/> </svg>
                                  </a>
                       </span>
                        <span data-toggle="dropdown" aria-expanded="false" @click="toggleNotesField" class="select-services-dropdown-add-label float-right"><a href="javascript:;" style="text-decoration: none; font-family: 'Roboto';font-style: normal;font-weight: 600;font-size: 14px;line-height: 24px;color: #2E4051;">Add notes to contact &nbsp;&nbsp;</a></span>
                    </div>
                </div>
            </div>
        </div>
        <!-- end notes section -->

    </div>

</template>

<script>

import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required, email} from 'vee-validate/dist/rules';
import Api from '../api/index.js';
import {isMobile} from "@/events/sharedMethods";

email.message = 'This is invalid email'
required.message = 'This field is required'

extend('email', email);
extend('required', required);

export default {
    name: "CustomerContactBox",
    props: ['index', 'dataSubmit', 'contactBox', "contactBoxTemp", "validationErrors", "countryData", "customerId"],
    components:{
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            apisData: {
                contactTitles: [
                    { key: 'dr', value: 'Dr.' },
                    { key: 'mr', value: 'Mr.' },
                    { key: 'mrs', value: 'Mrs.' },
                    { key: 'miss', value: 'Miss.' },
                    { key: 'ms', value: 'Ms.' },
                ],
                countriesData: null,
            },
            windowWidth: this.getScreenWidth(),
            showNotesField: false,
        }
    },
    methods: {
        isMobile,
        deleteContactBox(index) {
            this.$emit('deleteContactBoxEvent', index);
        },
        addContactBox() {
            if (this.dataSubmit.contactBoxes.length < 3) {
                this.dataSubmit.contactBoxes.push(JSON.parse(JSON.stringify(this.contactBoxTemp)));
            }
        },
        addInput(inputType) {
            let targetInputsArr;
            let obj;
            switch (inputType) {
                case 'name':
                    targetInputsArr = this.dataSubmit.contactBoxes[this.index].nameInputs;
                    obj = JSON.parse(JSON.stringify(this.contactBoxTemp.nameInputs[0]));
                break;
                case 'email':
                    targetInputsArr = this.dataSubmit.contactBoxes[this.index].emailInputs;
                    obj = JSON.parse(JSON.stringify(this.contactBoxTemp.emailInputs[0]));
                break;
                case 'mobile':
                    targetInputsArr = this.dataSubmit.contactBoxes[this.index].mobileInputs;
                    obj = JSON.parse(JSON.stringify(this.contactBoxTemp.mobileInputs[0]));
                break;
                case 'phone':
                    targetInputsArr = this.dataSubmit.contactBoxes[this.index].phoneInputs;
                    obj = JSON.parse(JSON.stringify(this.contactBoxTemp.phoneInputs[0]));
                break;
            }
            if (targetInputsArr.length < 3) targetInputsArr.push(obj);
        },
        deleteInput(inputType, index) {

            let targetInputsArr;
            switch (inputType) {
                case 'name':  targetInputsArr = this.dataSubmit.contactBoxes[this.index].nameInputs; break;
                case 'email': targetInputsArr = this.dataSubmit.contactBoxes[this.index].emailInputs; break;
                case 'mobile': targetInputsArr = this.dataSubmit.contactBoxes[this.index].mobileInputs; break;
                case 'phone': targetInputsArr = this.dataSubmit.contactBoxes[this.index].phoneInputs; break;
            }
            targetInputsArr.splice(index, 1);
        },
        getCountriesData() {
            let vm = this;
            Api.getCountriesData().then((data) => { vm.apisData.countriesData = data.data; });
        },
        getScreenWidth() {
            let xWidth = null;
            if (window.screen != null)
                xWidth = window.screen.availWidth;

            if (window.innerWidth != null)
                xWidth = window.innerWidth;

            if (document.body != null)
                xWidth = document.body.clientWidth;

            return xWidth;
        },
        updateSelectedText(ref,code){
            this.$nextTick(() => {
                let element  = this.$refs[ref][0]
                console.log(element)
                let selectedIndex = element.selectedIndex
                console.log(selectedIndex)
                element.options[selectedIndex].innerHTML = '+'+code.split('_')[0]
                for(let index in element.options) {
                    if (index != selectedIndex) {
                        if (((element.options[index] || {}).dataset || {}).text) {
                            element.options[index].text = element.options[index].dataset.text
                        }
                    }
                }
            });
        },
        toggleNotesField() {
            this.showNotesField = !this.showNotesField;
        }
    },
    created() {
        this.getCountriesData();
    },
}
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.border-none {
    border: none;
}

.contact-container-number {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    color: #2E4051;
}
.large-contact-container-number {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #2E4051;
}

.contactBox .attribute-label {
    font-family: Roboto;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: rgb(46, 64, 81);
}

.contact-new-input {
    width: 100%;
    height: 48px;
    padding: 14px 16px;
    border-radius: 8px;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(218, 222, 226);
    border-image: initial;
    background: #FFFFFF;
}

.first-name-position {
    position: relative;
    left: 24px;
}

.input-group-addon-new-design-right {
    border-radius: 0px 8px 8px 0px !important;
}

.input-group-new-design-left {
    border-radius: 8px 0px 0px 8px !important;
}

.width-unset {
    width: unset;
}

input:focus{
    outline: none !important;
    border:1px solid rgb(218, 222, 226) !important;
}

select:focus{
    outline: none !important;
    border:1px solid rgb(218, 222, 226) !important;
}

.input-group select:focus{
    outline: none !important;
    border:1px solid #FFFFFF !important;
}

input::placeholder{
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #979FA8;
}

.has-error {
    border-color: #a94442 !important;
}

label {
    display: block;
    position: absolute;
    top: 22%;
    transform: translateY(-50%);
    left: 32px;
    color: #2E4051;
    transform-origin: left top;
    user-select: none;
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1),color 150ms cubic-bezier(0.4, 0, 0.2, 1), top 500ms;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
}

.p-bottom-0-imp {
    padding-bottom: 0 !important;
}

.left-48 {
    left: 48%;
}
@media (min-width: 375px) and (max-width: 389px){
    #countryCode {
        width: 55px;
    }
}
@media (min-width: 390px) and (max-width: 413px){
    #countryCode {
        width: 60px;
    }
}
@media (min-width: 413px) and (max-width: 414px){
    #countryCode {
        width: 66px;
    }
}
@media (min-width: 415px) and (max-width: 424px){
    #countryCode {
        width: 33px;
    }
}
@media (min-width: 425px) and (max-width: 767px){
    #countryCode {
        width: 76px;
    }
}
@media (min-width: 767px) and (max-width: 768px){
    #countryCode {
        width: 66px;
    }
}
@media (min-width: 769px) and (max-width: 820px){
    #countryCode {
        width: 52px;
    }
}
@media (max-width: 767px) {
    .first-name-position {
        left: 0px;
        left: -10px;
    }
    .contact-new-input{
         width: 100% !important;
     }
    .width-108-mobile {
        width: 108% !important;
    }
    .width-106-mobile {
        width: 106% !important;
    }
    .width-auto-mobile {
        width: auto !important;
    }
    .left-48{
        left: 30% !important;
    }
    .input-group-addon{
        border-width: 1px !important;
        border-style: solid !important;
        border-color: rgb(218, 222, 226) !important;
    }
    .row {
        padding-bottom: 0px !important;
    }
    .mobile-m-top-5 {
        margin-top: 5px;
    }
    .width-109-mobile {
        width: 108% !important;
    }

}
@media (min-width: 768px) and (max-width: 820px){
    .first-name-position {
        left: -18px;
        padding-bottom: 20px;
    }
    .contact-new-input{
         width: 100% !important;
     }
    .width-108-mobile {
        width: 108% !important;
    }
    .width-106-mobile {
        width: 106% !important;
    }
    .width-auto-mobile {
        width: auto !important;
    }
    .width-109-mobile {
        width: 109% !important;
    }

}
@media (min-width: 822px) and (max-width: 1024px) {
    .contact-new-input {
        width: 100% !important;
    }
    .width-auto-mobile {
        width: auto !important;
    }
    #countryCode {
        width: 144px;
    }
    .ipad-padding {
        padding-right: 32px;;
    }
    .label-left{
        left: 24px;
    }
}
@media (min-width: 360px) and (max-width: 374px){
    .width-auto-mobile{
        width: 111% !important;
    }
    #countryCode {
        width: 55px;
    }
}
@media (min-width: 1025px) and (max-width: 1440px) {
    .width-unset {
        width: 66px !important;
    }
}
</style>